import React from "react"

export default function Checkbox(props) {
  const { title } = props
  switch(title) {
    case '':
      return ( 
        <label class="checkboxRow">
          <input type="checkbox" id="checkbox" hidden />
            <div className="checkbox">
              <div class="checkboxIcon"></div>
            </div>
        </label> 
      )
    default:
      return (
        <label class="checkboxRow">
          <input type="checkbox" id="checkbox" hidden />
            <div className="checkbox">
              <div class="checkboxIcon"></div>
            </div>

            <span class="checkboxTitle">{props.title}</span>
        </label> 
      )
  }
}
